module.exports = __webpack_public_path__ + "img/saum_beige_ohneral.4bf2be80.jpg";